// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"324":"9f1287fa","366":"03dcecb1","455":"a129e7af","977":"fe335e55"}[chunkId] + ".chunk.js";
};